/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_FreezerInputs */

const en_filter_freezer = /** @type {(inputs: Filter_FreezerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freezer`)
};

const de_filter_freezer = /** @type {(inputs: Filter_FreezerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfrieren`)
};

/**
* | output |
* | --- |
* | "Freezer" |
*
* @param {Filter_FreezerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_freezer = /** @type {((inputs?: Filter_FreezerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_FreezerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_freezer(inputs)
	return en_filter_freezer(inputs)
});